import success1Go from '@p2p/assets/img/success-1go.png';
import successDrip from '@p2p/assets/img/success-drip.png';
import successFlash from '@p2p/assets/img/success-flash.png';
import successImg from '@p2p/assets/img/success-image.png';
import successIzzi from '@p2p/assets/img/success-izzi.png';
import successJet from '@p2p/assets/img/success-jet.png';
import successLegzo from '@p2p/assets/img/success-legzo.png';
import successMonro from '@p2p/assets/img/success-monro.png';
import successSol from '@p2p/assets/img/success-sol.png';
import successStarda from '@p2p/assets/img/success-starda.png';
import successVolna from '@p2p/assets/img/success-volna.png';
import { useTimer } from '@p2p/entities/payment';
import { TGetOrderResponse } from '@p2p/services';
import { getOrderAmount } from '@p2p/shared/functions';
import classNames from 'classnames';
import { useCallback, useMemo } from 'react';

import { TransferCard, TransferHead, TransferLogo } from '..';
import styles from './TransferSuccess.module.scss';

type TransferSuccessProps = {
  order: TGetOrderResponse;
  id: string;
};

const COUNT_SECONDS = 5;

export const TransferSuccess = ({ order, id }: TransferSuccessProps) => {
  const handleSuccess = useCallback(() => {
    window.location.replace(order?.merchant_success_page);
  }, [order?.merchant_success_page]);
  const { second, locateWordSecond } = useTimer({
    time: COUNT_SECONDS,
    onTimeout: handleSuccess,
  });

  const themeName: string = order?.payment_form?.split('_')?.[0];
  const successImage = useMemo(() => {
    switch (themeName) {
      case 'fresh':
        return successFlash;
      case 'sol':
        return successSol;
      case 'jet':
        return successJet;
      case 'volna':
        return successVolna;
      case 'starda':
        return successStarda;
      case 'drip':
        return successDrip;
      case 'izzi':
        return successIzzi;
      case 'legzo':
        return successLegzo;
      case 'onego':
        return success1Go;
      case 'monro':
        return successMonro;
      default:
        return successImg;
    }
  }, [themeName]);

  return (
    <main className={classNames(styles.payment_page, styles.warning, styles[themeName])}>
      <TransferLogo />
      <div className={styles.payment_dialog}>
        <TransferHead id={id} status={themeName} />
        <div className={styles.payment_dialog__body}>
          <TransferCard
            time={order?.time_left || 0}
            price={getOrderAmount(order)}
            code={order?.currency_code_to}
            status={themeName}
          />
          <div className={styles.status_block}>
            <div>
              <img src={successImage} alt="" />
            </div>
            <div className={styles.status_block__title}>Оплата прошла успешно!</div>
            <div className={styles.status_block__description}>
              Мы перенаправим вас на сайт через {second} {locateWordSecond}
            </div>
          </div>
          <a
            href={order?.merchant_success_page}
            className={classNames(styles.btn, styles.btn_secondary)}
          >
            Вернуться на сайт
          </a>
        </div>
      </div>
    </main>
  );
};
